<template>
  <!-- 组织机构  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <common-slide :slideList="titleList"></common-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left{
   width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right{
  width: 890px;
}
</style>

<script>
import commonSlide from "./../common/slide.vue";
export default {
  data() {
    return {
      titleList: [
        {
          title: "中心简介",
          routerName: "centerIntro"
        },
        {
          title: "组织结构图",
          routerName: "centerMap"
        },
        {
          title: "资质证书",
          routerName: "centerCate"
        },
        {
          title: "中心领导",
          routerName: "centerLeader"
        },
        // {
        //   title: "部门职责",
        //   routerName: "centerDuty"
        // }
      ]
    };
  },
  components: {
    commonSlide
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Organization/index.vue